import { loadSecure } from './crypto';
import { providerOf } from './models';
import { api } from './api';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Admin AI calls: always the owner's own key from the encrypted device settings. */
export async function byokPayload() {
  const s = await loadSecure('settings');
  if (!s?.apiKey) throw new Error('Configura la tua chiave API personale in Config');
  return aiPayload({ ...s, aiMode: 'byok' });
}

/** OpenAI key for covers: dedicated cover key, else the main key when it is OpenAI. */
export async function coverPayload() {
  const s = await loadSecure('settings');
  const main = (s?.byokProvider || providerOf(s?.byokModel)) === 'openai' ? s?.apiKey : null;
  const key = s?.coverKey || main;
  if (!key) throw new Error('Inserisci una chiave OpenAI per le copertine in Config');
  return { openai_key: key };
}

export function aiPayload(settings) {
  const byok = settings.aiMode === 'byok';
  return { ai_mode: settings.aiMode, model: byok ? settings.byokModel : settings.universalModel, api_key: byok ? settings.apiKey : null, provider: byok ? settings.byokProvider || providerOf(settings.byokModel) : null };
}

export async function waitJob(job_id, signal) {
  for (;;) {
    if (signal?.aborted) throw new DOMException('Annullato', 'AbortError');
    await new Promise((ok) => setTimeout(ok, 1500));
    let j;
    try { j = await api(`/architect/jobs/${job_id}`, { auth: true, timeout: 15000 }); } catch (e) { if (e.status) throw e; continue; }
    if (j.status === 'error') throw new Error(j.error || 'Errore IA');
    if (j.status === 'done') return j.text;
  }
}

export async function streamArchitect(body, onToken, signal, onStatus) {
  const { job_id } = await api('/architect/jobs', { method: 'POST', body, auth: true });
  const cancel = () => api(`/architect/jobs/${job_id}`, { method: 'DELETE', auth: true }).catch(() => {});
  signal?.addEventListener('abort', cancel);
  const started = Date.now();
  let shown = '';
  for (;;) {
    if (signal?.aborted) throw new DOMException('Annullato', 'AbortError');
    await new Promise((ok) => setTimeout(ok, 1200));
    let j;
    try { j = await api(`/architect/jobs/${job_id}`, { auth: true, timeout: 15000 }); } catch (e) { if (e.status) throw e; continue; }
    onStatus?.(j.status, Math.round((Date.now() - started) / 1000));
    if (j.text && j.text !== shown) { shown = j.text; onToken(shown); }
    if (j.status === 'error') throw new Error(j.error || 'Errore IA');
    if (j.status === 'done' || j.status === 'cancelled') return j.text;
    if (Date.now() - started > 15 * 60 * 1000) throw new Error('Tempo scaduto: riprova con una richiesta più semplice');
  }
}

export async function pingArchitect(payload) {
  return api('/architect/ping', { method: 'POST', body: payload, auth: true, timeout: payload.ai_mode === 'byok' ? 10000 : 30000 });
}

export function extractCode(text) {
  const blocks = [...text.matchAll(/```(?:html|HTML)?\s*\n([\s\S]*?)```/g)].map((m) => m[1]).filter((b) => /<\/html>|<script/i.test(b));
  if (blocks.length) return blocks[blocks.length - 1].trim();
  const i = text.search(/<!DOCTYPE html|<html/i);
  if (i >= 0 && /<\/html>/i.test(text)) return text.slice(i, text.search(/<\/html>/i) + 7);
  return null;
}

export function stripCode(text) {
  return text.replace(/```(?:html|HTML)?\s*\n[\s\S]*?(```|$)/g, '\n[[CODE]]\n').trim();
}
